import React, { useState, useEffect, useCallback } from 'react';

import { fetchAllTravelWithExpensesByUser } from 'actions/expense';
import { TravelsWithExpensesResponse, TravelsWithExpensesFilters } from 'models/expense';
import ExpenseTravelsList from 'screens/components/ExpenseTravelsList';

const TravelsWithExpensesList = () => {
  const [data, setData] = useState<TravelsWithExpensesResponse>();
  const [filters, setFilters] = useState<TravelsWithExpensesFilters>({});
  const [isInitializing, setInitializing] = useState(true);
  const [isLoading, setLoading] = useState(false);
  const [period, setPeriod] = useState('');

  const fetchTravels = useCallback(async () => {
    const {
      data: { data: response },
    } = await fetchAllTravelWithExpensesByUser(filters);
    setData(response);
  }, [filters]);

  useEffect(() => {
    const fetch = async () => {
      await fetchTravels();
      setInitializing(false);
      setLoading(false);
    };

    fetch();
  }, [fetchTravels]);

  const filterTravels = async (newFilters: TravelsWithExpensesFilters, period: string) => {
    setLoading(true);
    setFilters(newFilters);
    setPeriod(period);
  };

  return (
    <ExpenseTravelsList
      loading={isLoading}
      initializing={isInitializing}
      travelsWithExpenses={data}
      handleFilter={filterTravels}
      initialPeriod={period}
      filters={filters}
    />
  );
};

export default TravelsWithExpensesList;
